module.exports = __webpack_public_path__ + "static/img/preview.41b34448.png";